<template>
    <div>
        <el-form label-position="left" label-width="100px">
            <el-row :gutter="10">
                <el-col :span="20">
                    <el-form-item label="学期类型">
                        <el-select v-model="filter.semester_type_id" placeholder="请选择" @change="handleTemplateDays">
                            <el-option
                                    v-for="item in $parentInfo.semesterTypes"
                                    :key="item.id"
                                    :label="item.name"
                                    :value="item.id">
                            </el-option>
                        </el-select>
                    </el-form-item>
                </el-col>
            </el-row>
            <el-row :gutter="10">
                <el-col :span="20">
                    <el-form-item label="模板">
                        <el-select v-model="filter.template_day_ids" multiple placeholder="请选择">
                            <el-option
                                    v-for="item in $parentInfo.dialog_GiveTemplateToSemester.template_days"
                                    :key="item.id"
                                    :label="item.name"
                                    :value="item.id">
                            </el-option>
                        </el-select>
                    </el-form-item>
                </el-col>
            </el-row>
            <el-row :gutter="10">
                <el-col :span="20">
                    <el-form-item label="被赋予学期">
                        <el-select v-model="filter.semester_ids" multiple placeholder="请选择">
                            <el-option
                                    v-for="item in $parentInfo.dialog_GiveTemplateToSemester.semesters"
                                    :key="item.id"
                                    :label="item.name"
                                    :value="item.id">
                            </el-option>
                        </el-select>
                    </el-form-item>
                </el-col>
            </el-row>
        </el-form>

        <div class="m-portlet__foot">
            <div style="text-align: right">
                <el-button @click="handleGiveTemplate" :loading="$parentInfo.dialog_GiveTemplateToSemester.button_loading">赋予</el-button>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: "Dialog_GiveTemplateToSemester",
        data() {
            return {
                filter:{
                    semester_type_id:'',
                    template_day_ids:'',
                    semester_ids:'',
                },

            }
        },
        created() {
            this.$parentInfo = this.$root.$children[0].$refs['dashboard'].$refs[this.$route.path];
        },
        methods: {
            handleGiveTemplate(){
                this.$parentInfo.dialog_GiveTemplateToSemester.button_loading=true;
                this.$wApi.send(this.$parentInfo.path, 'give_template_to_semester', {'filter':this.filter});
            },
            handleTemplateDays(){
                this.$wApi.send(this.$parentInfo.path, 'get_template_and_semester', {'semester_type_id':this.filter.semester_type_id});
            }
        }
    }
</script>

<style scoped>

</style>